import { LOCALES } from 'i18n/locales';

export const workpackAlertSuccessIntl = {
    [LOCALES.ENGLISH]: {
        'workpackAlerts.success.title': 'PDF created'
    },
    [LOCALES.WELSH]: {
        'workpackAlerts.success.title': '[PDF created]'

    }
};

export const WorkpackAlertSuccessIntl = workpackAlertSuccessIntl;
